/**
 * "Additional Notes From Tenant" callout (design §7) — the review step's
 * free-text notes, rendered in quotes. The page only mounts this when notes
 * exist.
 */
import { cn } from '#app/utils/misc'
import { DETAIL_CARD, IconSquare } from '../primitives'

export function AdditionalNotes({ notes }: { notes: string }) {
	return (
		<section className={cn(DETAIL_CARD, 'p-6 sm:p-7')}>
			<div className="flex items-center gap-3">
				<IconSquare tone="purple">
					<img src="/img/fileplus.svg" alt="fileplus" />
				</IconSquare>
				<h2 className="text-[16px] font-semibold text-[#32302F]">
					Additional Notes From Tenant
				</h2>
			</div>
			<p className="mt-4 text-[15px] leading-relaxed whitespace-pre-wrap text-[#747474]">
				&ldquo;{notes}&rdquo;
			</p>
		</section>
	)
}
